
























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class SearchField extends Vue {
  search: string = ''

  @Prop({ default: 'Effectuer une recherche...'})
  placeholder:any

  @Prop({ default: false })
  loading:any

  @Prop({ default: null })
  initialValue:any

  @Prop({ type: Boolean, default: false })
  history!:boolean

  @Watch('search')
  emit(value:any) {
    this.$emit('searching')
  }

  clearSearch() {
    this.search = ''
    this.$emit('clear')
  }

  get isEmpty() {
    return this.search == ''
  }

  emitValue() {
    this.$emit('search', this.search)
    if (this.history) {
      this.$urlManager.setUrlParameter('search', this.search)
    }
  }

  mounted() {
    if (!this.initialValue && !this.history) return
    if (this.initialValue) {
      this.search = this.initialValue
    }
    else if (this.history) {
      this.$urlManager.registerUrlParameter('search', () => {
        this.search = this.$urlManager.getUrlParameter('search')
        this.$emit('search', this.search)
      }, 'page')
      this.search = this.$urlManager.getUrlParameter('search')
    }
    this.$emit('search', this.search)
  }

  beforeDestroy() {
    if (this.history) {
      this.$urlManager.deleteUrlParameter('search')
    }
  }
}
